import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import axios from 'axios'
import { Table, Icon } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import { getProjectList } from './ApiUtils'
import { CostApprovedRow, SalesPersonApprovedRow} from './UiUtils'




class ViewLargeProjects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerName: '',
            phone1: '',
            contactPerson1: '',
            loading: false,
            projects: []
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");
        console.log("filtx: filter:"+this.props.filter)

        // this.getProjectList();

        
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    //  this.getApiDetails();
                    //this.getProjectList();
                    getProjectList(this.loadProjectList,this.props.filter, this.props.salesPersonId)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    loadProjectList = (projects) => {
      //  console.log("gpx12 ++++++++:loadProjectList");

        if (projects && projects.length > 0) {
            this.setState({
                projects: projects
            })
        } else {
            alert("unable to load projects")
        }
    }


    render() {




        const rows = this.state.projects.length > 0
            ? this.state.projects.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.idlargeprojects} </Table.Cell>
                    <Table.Cell> {item.name} </Table.Cell>
                    <Table.Cell> {item.largeprojectcustomer.customername} </Table.Cell>
                    <Table.Cell> {item.datecreated} </Table.Cell>
                    <Table.Cell> {toCurrency(item.totalpayment)} </Table.Cell>
                    <Table.Cell> {item.enteredby.name} </Table.Cell>
                    <Table.Cell> {item.paymentstatus}</Table.Cell>
                    <Table.Cell> {item.salesperson.name}</Table.Cell>
                    <Table.Cell> <Link to={'/dashboard/viewLargeProject/' + item.idlargeprojects}>EDIT</Link></Table.Cell>
                    <CostApprovedRow item={item} />
                    {/* <SalesPersonApprovedRow item={item} /> */}
                    <Table.Cell> <SalesPersonApprovedRow item={item} /></Table.Cell>
                </Table.Row>)
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <h2>PROJECTS</h2>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Id</Table.HeaderCell>
                            <Table.HeaderCell>Project</Table.HeaderCell>
                            <Table.HeaderCell>Customer</Table.HeaderCell>
                            <Table.HeaderCell>Date Created</Table.HeaderCell>
                            <Table.HeaderCell>Total Cost</Table.HeaderCell>
                            <Table.HeaderCell>Entered By</Table.HeaderCell>
                            <Table.HeaderCell>PAID</Table.HeaderCell>
                            <Table.HeaderCell>SALES PERSON</Table.HeaderCell>
                            <Table.HeaderCell>EDIT</Table.HeaderCell>
                            <Table.HeaderCell>Costs Appr</Table.HeaderCell>
                            <Table.HeaderCell>SalesPrsn Appr</Table.HeaderCell>

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rows}
                    </Table.Body>

                </Table>
            </div>
        );
    }
}

export default ViewLargeProjects;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewLargeProjects.js